import Link from 'next/link';
import React, { useRef } from 'react';
import SwiperCore from 'swiper';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import Icon, { IconType } from '@/components/icons';
import { Article } from '@/types/Article';

import B2BArticleCard, { ArticleCardType } from '../b2b-article-card/b2b-article-card';
import styles from './b2b-related-articles.module.scss';
import BusinessButton from '@/components/business-button/business-button';
import { COLORS } from '@/components/business-button/business-button.constants';

SwiperCore.use([Navigation]);
export interface B2BRelatedArticlesProps {
    title: string;
    description?: string;
    viewAllSeriesText: string;
    viewAllSeriesUrl: string;
    articles: Article[];
}
interface Props {
    relatedArticles: B2BRelatedArticlesProps;
}

const B2BRelatedArticles: React.FC<Props> = (props: Props) => {
    const { title, description, viewAllSeriesText, viewAllSeriesUrl, articles } = props.relatedArticles;

    if (!articles || articles.length === 0) {
        return null;
    }

    return (
        <div className={styles.relatedArticlesContainer}>
            <div className={styles.relatedArticlesHeader}>
                <div className={styles.relatedArticlesHeaderInfo}>
                    <div className={styles.relatedArticlesHeaderTitle}>{title}</div>
                    <div className={styles.relatedArticlesHeaderDescription}>{description}</div>
                </div>
            </div>
            <div className={styles.relatedArticleSlider}>
                <Swiper
                    key={title}
                    slidesPerView={'auto'}
                    spaceBetween={8}
                    centeredSlides={true}
                    centeredSlidesBounds={true}
                    watchOverflow={true}
                    lazyPreloadPrevNext={1}
                    updateOnWindowResize={true}
                    className={styles.relatedArticleSliderSeoSeriesSlider}
                    breakpoints={{
                        1440: {
                            spaceBetween: 24,
                        },
                    }}
                >
                    {(articles || []).map((article: Article) => {
                        return (
                            <SwiperSlide className={styles.relatedArticleSlide} key={article.articleUrl}>
                                <B2BArticleCard type={ArticleCardType.Small} article={article} />
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
            <BusinessButton
                className={styles.relatedArticlesViewAll}
                link={viewAllSeriesUrl}
                icon={IconType.ArrowRightSmall}
                autoMargin={false}
                color={COLORS.BLACK}
                target="_self"
                buttonText={viewAllSeriesText}
            />
        </div>
    );
};

export default B2BRelatedArticles;
